export const LIVE_ACTIVITY_SUFFIX = '-LIVE';
export const PERSONAL_CHANNEL_SUFFIX = '-PERSONAL';

export const SOCKET_EVENT_NAMES = {
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    ACTION: 'action',
    UPDATE_CHANNELS: 'update-channels',
};
